import { Map } from 'immutable';
import {
  CodeMismatchException,
  ExpiredCodeException,
  InvalidPasswordException,
  LimitExceededException,
  MessageRejectedException,
  NotAuthorizedException,
  TooManyFailedAttemptsException,
  UserNotConfirmedException,
} from './cognito/cognito-errors';
import {
  HttpForbiddenException,
  HttpUnauthorizedException,
} from './http/http-errors';
import {
  DuplicateEquipmentSerialException,
  InvalidSerialException,
  InvalidSerialNumberException,
  UnableToConnectSAPException,
} from './product-service/product-service-errors';
import { RewardCannotBeRedeemedException } from './reward-service/reward-service-errors';
import {
  BusinessWebsiteAlreadyExistsException,
  EquipmentNotFoundException,
  InvalidHashException,
  RepresentativeAlreadyExistsException,
  RepresentativeLimitReachedException,
  SerialValidationException,
} from './user-management-service/user-management-service-errors';

const errors = Map({
  'CGN-UNC-001': new UserNotConfirmedException(),
  'CGN-TFA-001': new TooManyFailedAttemptsException(),
  'CGN-NAE-001': new NotAuthorizedException(),
  'CGN-CME–001': new CodeMismatchException(),
  'CGN-ECE-001': new ExpiredCodeException(),
  'CGN-LEE-001': new LimitExceededException(),
  'CGN-PWE-001': new InvalidPasswordException(),
  'GNR-VLE-001': new SerialValidationException(),
  'PRD-DES-001': new DuplicateEquipmentSerialException(),
  'RWD-RRB-001': new RewardCannotBeRedeemedException(),
  'SES-MRE-001': new MessageRejectedException(),
  'UMS-IHE-001': new InvalidHashException(),
  'UMS-RLR-001': new RepresentativeLimitReachedException(),
  'UMS-ENF-001': new EquipmentNotFoundException(),
  'UMS-WAE-001': new BusinessWebsiteAlreadyExistsException(),
  'UMS-RAE-001': new RepresentativeAlreadyExistsException(),
  'SAP-ISE-001': new InvalidSerialException(),
  'HTTP-403': new HttpForbiddenException(),
  'HTTP-401': new HttpUnauthorizedException(),
  'PRD-UCS-001': new UnableToConnectSAPException(),
  'PRD-UCS-002': new InvalidSerialNumberException(),
});

export default errors;
